export const ARCHIVE_TABLE_COLUMN_KEYS = {
	SELECT: 'select',
	TYPE: 'type',
	KEY: 'key',
	SUMMARY: 'summary',
	ARCHIVED_BY: 'archivedBy',
	REPORTER: 'reporter',
	ARCHIVED_DATE: 'archived-date',
};

export const ARCHIVE_TABLE_COLUMN_WIDTHS: {
	[key in keyof typeof ARCHIVE_TABLE_COLUMN_KEYS]: number;
} = {
	SELECT: 4,
	TYPE: 5,
	KEY: 12,
	SUMMARY: 42,
	ARCHIVED_BY: 16,
	REPORTER: 16,
	ARCHIVED_DATE: 12,
};

export const ARCHIVES_TABLE_TEST_ID = 'issue-archival-archives.archives-table' as const;

export const NUMBER_OF_ISSUES_PER_PAGE = 50 as const;
export const POPUP_WIDTH = 360;
export const POPUP_PADDING = 20;
export const SHOW_MORE_OPTIONS_BTN_SIZE = 32;
export const OPTIONS_AVAILABLE_WIDTH = POPUP_WIDTH - POPUP_PADDING * 2;
export const GAP_BETWEEN_OPTION = 4;
export const OPTION_SPAN_PADDING = 16;
export const OPTION_DEFAULT_FONT_SIZE = 14;
export const OPTION_HEIGHT = 28;
export const OPTION_MAX_WIDTH = 150;
